import { render, staticRenderFns } from "./ModalBMHCForDisease.vue?vue&type=template&id=d93d2406"
import script from "./ModalBMHCForDisease.vue?vue&type=script&lang=js"
export * from "./ModalBMHCForDisease.vue?vue&type=script&lang=js"
import style0 from "./ModalBMHCForDisease.vue?vue&type=style&index=0&id=d93d2406&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports